import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { GlobalStateContext } from './GlobalState';

const PlaylistTableInline = ({ list_id, list_name }) => {
  const { isLoggedInSpotify } = useContext(GlobalStateContext);
  const navigate = useNavigate();

  const handleLoadPlaylist = async () => {
    try {
      const response = await fetch(`/playlistx?list_id=${list_id}${!isLoggedInSpotify ? '&public=true' : ''}`);
      if (response.status === 401) {
        window.location.href = '/';
        return;
      }
      const data = await response.json();
      navigate('/builder/playlist', { 
        state: { 
          songs: data,
          playlistName: list_name 
        }
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Button variant="primary" onClick={handleLoadPlaylist}>
      {list_name}
    </Button>
  );
};

export default PlaylistTableInline;
